// Function to update the visual price slider track
function updateIshaSliders() {
  const rangeWrappers = document.querySelectorAll('.isha-range-slider');
  rangeWrappers.forEach(wrap => {
    const minInput = wrap.querySelector('.isha-range-min');
    const maxInput = wrap.querySelector('.isha-range-max');
    const track = wrap.querySelector('.isha-slider-track');
    const minDisplay = wrap.parentElement.querySelector('.isha-min-text');
    const maxDisplay = wrap.parentElement.querySelector('.isha-max-text');

    if(!minInput || !maxInput || !track) return;

    function adjustTrack() {
      let minVal = parseInt(minInput.value) || 0;
      let maxVal = parseInt(maxInput.value) || 0;
      const maxLimit = parseInt(maxInput.max) || 100;

      // Prevent thumbs from crossing
      if (minVal >= maxVal) {
        if (this === minInput) { minInput.value = maxVal; minVal = maxVal; }
        else { maxInput.value = minVal; maxVal = minVal; }
      }

      if (minDisplay) minDisplay.textContent = minVal;
      if (maxDisplay) maxDisplay.textContent = maxVal;

      const minPercent = (minVal / maxLimit) * 100;
      const maxPercent = (maxVal / maxLimit) * 100;
      
      track.style.left = minPercent + '%';
      track.style.width = (maxPercent - minPercent) + '%';
    }

    minInput.addEventListener('input', adjustTrack);
    maxInput.addEventListener('input', adjustTrack);
    adjustTrack(); // Initialize on load
  });
}

// Function to fetch and replace the grid
function submitIshaFilters() {
  const filterForm = document.getElementById('isha-filter-form');
  const collectionContent = document.getElementById('isha-collection-content');
  if (!filterForm || !collectionContent) return;

  collectionContent.classList.add('isha-grid-loading');

  const formData = new FormData(filterForm);
  const searchParams = new URLSearchParams(formData);
  
  for (const [key, value] of Array.from(searchParams.entries())) {
    if (!value) searchParams.delete(key);
  }

  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState({}, '', newUrl);

  fetch(newUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.getElementById('isha-collection-content');
      
      if (newGrid) {
        collectionContent.innerHTML = newGrid.innerHTML;
      }
      collectionContent.classList.remove('isha-grid-loading');
      updateIshaSliders(); // Reconnect sliders without reloading the whole page
    })
    .catch(error => {
      console.error('Filter Error:', error);
      collectionContent.classList.remove('isha-grid-loading');
    });
}

// Global Event Listeners (Attached only ONCE to prevent lag)
document.addEventListener('DOMContentLoaded', function() {
  updateIshaSliders();
});

document.addEventListener('click', function(e) {
  // Toggle Dropdowns
  if (e.target.closest('.isha-filter-toggle')) {
    const btn = e.target.closest('.isha-filter-toggle');
    const menu = btn.nextElementSibling;
    document.querySelectorAll('.isha-filter-menu.is-open').forEach(openMenu => {
      if (openMenu !== menu) openMenu.classList.remove('is-open');
    });
    menu.classList.toggle('is-open');
  }

  // Close dropdowns if clicking outside
  if (!e.target.closest('.isha-dropdown-container')) {
    document.querySelectorAll('.isha-filter-menu.is-open').forEach(menu => {
      menu.classList.remove('is-open');
    });
  }

  // Apply Button
  if (e.target.classList.contains('isha-btn-apply')) {
    e.target.closest('.isha-filter-menu').classList.remove('is-open');
    submitIshaFilters();
  }

  // Clear Button (Checkboxes)
  if (e.target.classList.contains('isha-btn-clear') && !e.target.classList.contains('isha-price-clear')) {
    const menu = e.target.closest('.isha-filter-menu');
    menu.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
    submitIshaFilters();
  }

  // Clear Button (Price Slider)
  if (e.target.classList.contains('isha-price-clear')) {
    const menu = e.target.closest('.isha-filter-menu');
    const minInput = menu.querySelector('.isha-range-min');
    const maxInput = menu.querySelector('.isha-range-max');
    minInput.value = 0;
    maxInput.value = maxInput.max;
    minInput.dispatchEvent(new Event('input')); // Force visual update
    submitIshaFilters();
  }

  // Reset Filters / Clear All
  if (e.target.classList.contains('isha-clear-all')) {
    window.location.href = window.location.pathname;
  }
});

document.addEventListener('change', function(e) {
  // Auto-Submit on Sorting
  if (e.target.id === 'SortBy') {
    submitIshaFilters();
  }
});